<template>
  <component
    :is="nonReactive"
    v-if="nonReactive"
    :class="{ icon: !noIconClass }"
    :aria-hidden="ariaHidden ? 'true' : undefined"
  />
</template>

<script setup lang="ts">
import { h, type VNode, type ComponentOptionsBase } from 'vue';

type SvgIconProps = {
  // @ts-expect-error
  image: ComponentOptionsBase | Record<any, any>;
  noIconClass?: boolean;
  ariaHidden?: boolean;
};

const props = withDefaults(defineProps<SvgIconProps>(), {
  ariaHidden: true,
});

const ensureViewbox = (svg: VNode) => {
  if (svg.props?.viewBox) return;
  if (!svg.props?.width || !svg.props?.height) {
    console.error(`an svg must have a viewBox or width & height!`, svg);
    return;
  }

  const w = svg.props.width.replace('px', '') || 0;
  const h = svg.props.height.replace('px', '') || 0;
  svg.props.viewBox = `0 0 ${w.trim()} ${h.trim()}`;
};

// Remove width & height to make icons full scalable.
const removeDimensions = (svg: VNode) => {
  delete svg.props?.width;
  delete svg.props?.height;
};

const nonReactive = computed(() => {
  try {
    const image = props.image?.render?.(h, []);
    if (!image) return undefined;
    ensureViewbox(image);
    removeDimensions(image);
    return image;
  } catch (e) {
    console.error(e);
  }
  return undefined;
});
</script>
